import {
  CLASSE_ANBIMA_COLUMN_KEY,
  LEAF_COLUMN_LABEL_TO_KEY,
  LOCKED_COLUMN_KEYS,
} from '@modules/consolidator/constants/wallet-asset-columns'

export const WALLET_COLUMNS_STORAGE_KEY = 'consolidador:wallet-visible-columns'

const KEY_TO_LEAF_LABEL = Object.keys(LEAF_COLUMN_LABEL_TO_KEY).reduce(
  (acc, label) => {
    acc[LEAF_COLUMN_LABEL_TO_KEY[label]] = label
    return acc
  },
  {}
)

export const selectorIdsToColumnKeys = (ids) => {
  if (!Array.isArray(ids)) return []
  return ids.map((id) => LEAF_COLUMN_LABEL_TO_KEY[id] || id)
}

export const columnKeysToSelectorIds = (keys) => {
  if (!Array.isArray(keys)) return []
  return keys.map((key) => KEY_TO_LEAF_LABEL[key] || key)
}

export const ensureLockedColumns = (keys) => {
  const base = Array.isArray(keys) ? keys.slice() : []
  LOCKED_COLUMN_KEYS.forEach((key) => {
    if (!base.includes(key)) base.push(key)
  })
  return base
}

export const getStoredColumnKeys = () => {
  const raw = localStorage.getItem(WALLET_COLUMNS_STORAGE_KEY)
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : null
  } catch (error) {
    return null
  }
}

// Migração one-shot: a Classe ANBIMA virou coluna padrão, e um `defaultOn`
// novo NÃO alcança quem já tem preferência salva — o array é regravado a cada
// mexida em QUALQUER coluna, então a maioria dos usuários está com uma
// preferência que nunca opinou sobre esta coluna e ficaria sem ela para
// sempre. Roda uma vez por navegador (mesmo molde da migração do switch
// legado `consolidator:show_classe_anbima`): depois disso, quem tirar a
// coluna continua sem ela, porque a flag já está gravada.
export const ANBIMA_COLUMN_MIGRATION_KEY =
  'consolidador:wallet-columns-anbima-default-v1'

export const migrateStoredColumnsForAnbima = (keys) => {
  const base = Array.isArray(keys) ? keys.slice() : []
  if (localStorage.getItem(ANBIMA_COLUMN_MIGRATION_KEY) === 'done') return base
  localStorage.setItem(ANBIMA_COLUMN_MIGRATION_KEY, 'done')
  if (!base.includes(CLASSE_ANBIMA_COLUMN_KEY)) {
    base.push(CLASSE_ANBIMA_COLUMN_KEY)
  }
  return base
}

export const setStoredColumnKeys = (keys) => {
  const safeKeys = Array.isArray(keys) ? keys : []
  localStorage.setItem(WALLET_COLUMNS_STORAGE_KEY, JSON.stringify(safeKeys))
}
